export default {
      id: "63,4-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#63,4",
      toString: function () {
        return this.url;
      }
    }